import axios from "axios";

export default axios.create({
  // baseURL: "http://agrico-api.bigio.id/api",

  baseURL:
    window.location.href.includes("dev") ||
    window.location.href.includes("localhost")
      ? "https://api.paboi.bigio.id/v1"
      : "https://api.paboi.bigio.id/v1",
});
